<div class="mt-3" id="signature-tab">
  <mat-expansion-panel expanded="true" class="mat-elevation-z0" disabled>
    <mat-expansion-panel-header>
      <mat-panel-title class="mat-panel-title panel-title">
        {{ "title.settings_footnote" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <form nz-form>
      <nz-table #rowsTable nzBordered [nzData]="dataFootNote" [nzShowPagination]="false" [nzFrontPagination]="false" style="overflow-x: auto !important;"
        class="ant-table-no-placeholder-border-bottom">
        <thead>
          <tr>
            <th class="text-center" nzWidth="10%"> {{ "enterprise_contract.panel_document.table_users.header.order_sign" | translate }}</th>
            <th class="text-center" nzWidth="30%">
              {{ "enterprise_contract.panel_document_view.table_user_forward.member" | translate }}
            </th>
            <th class="text-center" nzWidth="10%">
              {{ "enterprise_contract.table_headers.role" | translate }}
            </th>
            <th class="text-center" nzWidth="20%">
              {{ "enterprise_contract.table_headers.choose_sign" | translate }}
            </th>
            <th class="text-center" nzWidth="30%">
              {{ "signature_config.real_page" | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
        <ng-container *ngFor="let data of listDataPeople; let j = index">
        <tr>
          <td class="text-left" style="background-color: #FFEDF1;
    color: black;
    font-weight: bold;">{{data.order}}</td>
          <td colspan="4" style="background-color: #FFEDF1;
    color: black;
    font-weight: bold;">
<!--            {{ "enterprise_contract.sign_table.approve_sign" | translate }}-->
            {{data.name}}
          </td>
        </tr>
        <tr *ngFor="let element of data.customerApproves; let i = index">
          <td class="text-right" *ngIf="(element.role == 2 || element.role == 7)">{{  i + 1 }}</td>
          <td *ngIf="element.role == 1"></td>
          <td  style="word-break: break-word">
            {{
            element.name
            }}
          </td>
          <td class="text-center" *ngIf="element.role == 1">{{'enterprise_contract.buttons.sign' | translate }}</td>
          <td class="text-center" *ngIf="element.role == 2 || element.role == 7" >{{'enterprise_contract.buttons.approve' | translate }}</td>
          <td *ngIf="element.role == 1 && element.isCreatedSide">
            <input nz-input [(ngModel)]="element.signatureName" disabled [title]="element.signatureName" type="text"
                   [ngModelOptions]="{ standalone: true }" id="inputUser" />
<!--            <nz-select  nzAllowClear [(ngModel)]="element.signatureId" [ngModelOptions]="{ standalone: true }" readonly="true"-->
<!--                       class="td-nz-input" [nzDisabled]="!optionsSignEnterprise.length" (ngModelChange)="changeSelect($event, element,i,j)" >-->
<!--              <nz-option *ngFor="let option of optionsSignEnterprise" [nzLabel]="option.signature.name" [nzValue]="option.signature.signatureId"></nz-option>-->
<!--            </nz-select>-->
          </td>
          <td *ngIf="element.role == 2 && element.isCreatedSide">
            <nz-select nzAllowClear [(ngModel)]="element.signatureId" [ngModelOptions]="{ standalone: true }"
                       class="td-nz-input" [nzDisabled]="!optionsSignApprover.length" (ngModelChange)="changeSelect($event, element,i,j)" >
              <nz-option *ngFor="let option of optionsSignApprover" [nzLabel]="option.signature.name" [nzValue]="option.signature.signatureId"></nz-option>
            </nz-select>
          </td>
          <td *ngIf="(element.role == 2 || element.role == 7) && !element.isCreatedSide">
            <nz-select nzAllowClear [(ngModel)]="element.signatureId" [ngModelOptions]="{ standalone: true }"
                       class="td-nz-input" [nzDisabled]="!optionsApproverCustomer1.length" (ngModelChange)="changeSelect($event, element,i,j)" >
              <nz-option *ngFor="let option of optionsApproverCustomer1" [nzLabel]="option.signature.name" [nzValue]="option.signature.signatureId"></nz-option>
            </nz-select>
          </td>
          <td *ngIf="element.role == 1 && !element.isCreatedSide">
            <nz-select nzAllowClear [(ngModel)]="element.signatureId" [ngModelOptions]="{ standalone: true }"
                       class="td-nz-input" [nzDisabled]="!optionsSignCustomer.length" (ngModelChange)="changeSelect($event, element,i,j)" >
              <nz-option *ngFor="let option of optionsSignCustomer" [nzLabel]="option.signature.name" [nzValue]="option.signature.signatureId"></nz-option>
            </nz-select>
          </td>
          <td class="text-center" >
            {{
            element.page
            }}
          </td>
        </tr>
          </ng-container>
<!--        <tr>-->
<!--          <td></td>-->
<!--          <td colspan="4">-->
<!--            {{ "enterprise_contract.sign_table.create_side" | translate }}-->
<!--          </td>-->
<!--        </tr>-->
<!--        <tr *ngFor="let data of rowsTable.data; let i = index">-->
<!--          <td *ngIf="data.signature.object === 'ENTERPRISE'" class="text-center">1</td>-->

<!--          <td *ngIf="data.signature.object === 'ENTERPRISE'" class="text-center word-break">-->
<!--            {{-->
<!--            data.signature && data.signature.name ? data.signature.name : ""-->
<!--            }}-->
<!--          </td>-->
<!--          <td></td>-->
<!--          <td *ngIf="data.signature.object === 'ENTERPRISE'">-->
<!--              <span class="customer-name" *ngIf="-->
<!--                data.signature &&-->
<!--                data.signature.object &&-->
<!--                data.signature.object === 'ENTERPRISE' &&-->
<!--                !createSide-->
<!--              ">{{ "signature_tab.create_side" | translate }}</span>-->
<!--            <span class="customer-name" *ngIf="-->
<!--                data.signature &&-->
<!--                data.signature.object &&-->
<!--                data.signature.object === 'ENTERPRISE' &&-->
<!--                createSide-->
<!--              ">{{ createSide && createSide.name ? createSide.name : "" }}</span>-->
<!--          </td>-->
<!--          <td class="text-center" *ngIf="data.signature.object === 'ENTERPRISE'">-->
<!--            {{-->
<!--            data.signature && data.signature.page ? data.signature.page : ""-->
<!--            }}-->
<!--          </td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--          <td></td>-->
<!--          <td colspan="4">-->
<!--            {{ "enterprise_contract.sign_table.customers" | translate }}-->
<!--          </td>-->
<!--        </tr>-->
<!--        <tr *ngFor="let data of rowsTable.data; let i = index">-->
<!--          <td *ngIf="data.signature.object === 'CUSTOMER'" class="text-center">{{ data.indexCustomer }}</td>-->

<!--          <td *ngIf="data.signature.object === 'CUSTOMER'" class="text-center word-break">-->
<!--            {{-->
<!--            data.signature && data.signature.name ? data.signature.name : ""-->
<!--            }}-->
<!--          </td>-->
<!--          <td></td>-->
<!--          <td *ngIf="data.signature.object === 'CUSTOMER'">-->
<!--            <nz-select nzAllowClear [(ngModel)]="data.customerId" [ngModelOptions]="{ standalone: true }"-->
<!--                       class="td-nz-input" [nzDisabled]="!optionsCustomer.length" (ngModelChange)="changeSelect($event, data)" *ngIf="-->
<!--                data.signature &&-->
<!--                (!data.signature.object || data.signature.object === 'CUSTOMER')-->
<!--              ">-->
<!--              <nz-option *ngFor="let option of optionsCustomer" [nzLabel]="option.name" [nzValue]="option.customerId"></nz-option>-->
<!--            </nz-select>-->
<!--          </td>-->
<!--          <td class="text-center" *ngIf="data.signature.object === 'CUSTOMER'">-->
<!--            {{-->
<!--            data.signature && data.signature.page ? data.signature.page : ""-->
<!--            }}-->
<!--          </td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--          <td></td>-->
<!--          <td colspan="4" *ngIf="lengthApproverCustomer > 0">-->
<!--            {{ "enterprise_contract.sign_table.approve_sign_customer" | translate }}-->
<!--          </td>-->
<!--        </tr>-->
<!--        <tr *ngFor="let data of rowsTable.data; let i = index">-->
<!--          <td *ngIf="data.signature.object === 'CUSTOMERAPPROVER'" class="text-center">{{ data.indexCustomerApprove }}</td>-->

<!--          <td *ngIf="data.signature.object === 'CUSTOMERAPPROVER'" class="text-center word-break">-->
<!--            {{-->
<!--            data.signature && data.signature.name ? data.signature.name : ""-->
<!--            }}-->
<!--          </td>-->
<!--          <td></td>-->
<!--          <td *ngIf="data.signature.object === 'CUSTOMERAPPROVER'">-->
<!--            <nz-select nzAllowClear [(ngModel)]="data.userId" [ngModelOptions]="{ standalone: true }"-->
<!--                       class="td-nz-input" [nzDisabled]="!optionsApprover.length" (ngModelChange)="changeSelect($event, data)" *ngIf="-->
<!--                data.signature &&-->
<!--                (!data.signature.object || data.signature.object === 'CUSTOMERAPPROVER')-->
<!--              ">-->
<!--              <nz-option *ngFor="let option of optionsApproverCustomer" [nzLabel]="option.name" [nzValue]="option.userId"></nz-option>-->
<!--            </nz-select>-->
<!--          </td>-->
<!--          <td class="text-center" *ngIf="data.signature.object === 'CUSTOMERAPPROVER'">-->
<!--            {{-->
<!--            data.signature && data.signature.page ? data.signature.page : ""-->
<!--            }}-->
<!--          </td>-->
<!--        </tr>-->
        </tbody>
      </nz-table>
    </form>
    <p class="mt-4">{{ "signature_tab.note" | translate }}</p>
  </mat-expansion-panel>
</div>
